import { createContext, useContext } from 'react';

export const PublicDataAccessContext = createContext(false);

export const usePublicDataAccess = () => useContext(PublicDataAccessContext);
